/**
 * Skimmer — 여러 자료의 텍스트 필드를 한 번에 훑어 찾는 경량 검색(flexmatch skimmer 와 같은 구조).
 * 타깃마다 검색 필드(전략)가 있고, 결과는 **타깃 엔티티별로 묶어** 돌려준다(필드별 묶음이 아니다).
 * 지금 타깃은 포트폴리오 하나(헤더 검색).
 */
export const SKIM_TARGET = { PORTFOLIO: 'portfolio' } as const;
export type SkimTarget = (typeof SKIM_TARGET)[keyof typeof SKIM_TARGET];

/** portfolio 타깃 검색 필드 — 모두 포트폴리오 id 로 묶인다 */
export const PORTFOLIO_SKIM_FIELD = {
  /** 회사명(info_portfolio.company_name) */
  NAME: 'name',
  /** 메모(portfolio_memo.content) — D3 만 */
  MEMO: 'memo',
  /** 영업현황 — 분기 리포트의 D3 사업 의미(comment_d3_business_meaning). LP 는 공개 리포트만 */
  REPORT: 'report',
  /** 연관 파트너 — 라운드 참여사(company_names) · 외부 투자자 이름 */
  PARTNER: 'partner',
} as const;
export type PortfolioSkimField = (typeof PORTFOLIO_SKIM_FIELD)[keyof typeof PORTFOLIO_SKIM_FIELD];

export const SKIM_LIMITS = {
  /** 이보다 짧은 검색어는 조회하지 않는다(빈 결과) */
  keywordMin: 2,
  keywordMax: 100,
  /** 필드마다 가져오는 최대 건수 */
  perFieldDefault: 30,
  perFieldMax: 30,
} as const;
